import { render, staticRenderFns } from "./viewEpisodeExtra.vue?vue&type=template&id=95f48618&scoped=true&"
import script from "./viewEpisodeExtra.vue?vue&type=script&lang=js&"
export * from "./viewEpisodeExtra.vue?vue&type=script&lang=js&"
import style0 from "./viewEpisodeExtra.vue?vue&type=style&index=0&id=95f48618&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95f48618",
  null
  
)

export default component.exports